import React, { useState } from "react";
import { Card, CardContent } from "@mui/material";
import useLanguage from "services/useLanguage";
import { icons, Shield } from "lucide-react";
import PaidIcon from "@mui/icons-material/PaidOutlined";

const PromptCard = ({ item, onItemClick = () => {} }) => {
  const currentLang = useLanguage();
  const IconComponent = (item.icon && icons[item.icon]) || Shield;

  return (
    <Card className="prompt-card" onClick={() => onItemClick(item)}>
      {/* Icon */}
      <div className="prompt-icon flex-shrink-0 flex items-center justify-center rounded-xl shadow-md">
        <IconComponent size={24} className="icon-inner" />
      </div>

      {/* Title & Description */}
      <CardContent sx={{ padding: 0 }}>
        <h6
          className="sub-card-title"
          title={
            item.title?.[currentLang] ||
            item.title?.It ||
            item.title?.En ||
            "Unnamed Prompt"
          }
        >
          {item.title?.[currentLang] ||
            item.title?.It ||
            item.title?.En ||
            "Unnamed Prompt"}
        </h6>
        <p
          className="prompt-description mt-1"
          title={
            item.description?.[currentLang] ||
            item.description?.It ||
            item.description?.En
          }
        >
          {item.description?.[currentLang] ||
            item.description?.It ||
            item.description?.En}
        </p>

        {item.prompt_cost && (
          <span className="absolute bottom-2 right-2 text-xs bg-gray-200 text-gray-700 px-2 py-1 rounded-full flex items-center gap-1">
            {item.prompt_cost}
            <PaidIcon
              sx={{ fontSize: 12, opacity: 0.8 }}
              className="badge-icon"
            />
            / prompt
          </span>
        )}
      </CardContent>
    </Card>
  );
};

export default PromptCard;
